import { Request as request } from "@/utils/request";
import { getLocalStorage, setLocalStorage } from "@/utils/common";

/**
 * 查询频道关注状态
 * @param {{chatid:string}} params  chatid 为频道id
 * @returns {} "data": false   true = 已加入频道，false = 未加入
 */
let queryingStatus = (params) => {
  return request("/api/common/check-chat-zozttx", {
    method: "POST",
    params,
  });
};

/**
 * 上报任务点击、完成数量
 * 当任务的record = 1的时候，需要统计点击与完成
 * @param {{
 * appid:number,
 * type:string
 * }} params
 * @param appid 任务的id
 * @param type 点击：click，任务完成：done
 * @returns
 */
let taskRecord = (params) => {
  return request("/api/common/task-record", {
    method: "POST",
    params,
  });
};

let getTask = () => {
  let ItemID = () => TApp_GlobalConfig.project_id; // 项目id
  let Domain_name = () => TApp_GlobalConfig.cdn_host; // 域名
  let time = Math.floor(Date.now() / 600000);
  return request(
    `https://${Domain_name()}/pages_config/${ItemID()}/task.json?t=${time}`,
    {
      method: "GET",
    },
  );
};

let check_boost = (params) => {
  return request("/api/common/check-boost-zozttx", {
    method: "POST",
    params,
  });
};

/**
 * 创建 Stars 订单
 * @param {string} id 任务 ID
 * @returns {Promise<Object>} 返回服务器响应
 * {
 * "code": 200,
 * "data": {
 * "order_id": "xxxx", // 订单号
 * "url": "t.me/xxx" // 付款链接
 * }
 * }
 */
let createStarsOrder3 = (id) => {
  return request("/api/common_v3/stars-create-order", {
    method: "POST",
    params: { id },
  });
};

/**
 * 检查 Stars 订单状态
 * @param {string} order_id 生成订单返回的订单号
 * @returns {Promise<Object>} 返回服务器响应
 * {
 * "code": 200,
 * "data": "wait" // wait: 等待付款，success: 付款成功
 * }
 */
let checkStarsOrderStatus = (order_id) => {
  return request("/api/common_v3/stars-check-order", {
    method: "POST",
    params: { order_id },
  });
};

/**
 * 任务领取奖励
 * @param {object} params
 * @param {string} params.task_id 任务id
 * @param {string} params.twa_id 用户id
 * @returns
 */
let taskReward = (params) => {
  return request("/api/common/task-reward", {
    method: "POST",
    params,
  });
};

let recordTask = async (taskid) => {
  if (getLocalStorage(taskid)) {
    return;
  }
  try {
    let res = await request("/api/common/app-record", {
      method: "POST",
      params: {
        taskid,
      },
    });
    if (res.code == 200) {
      setLocalStorage(taskid, true);
      return true;
    }
  } catch (error) {
    console.log(error);
  }
  return false;
};

// /api/common/fetch-shareinfo 获取用户名列表
let fetchShareinfo = (params) => {
  return request("/api/common/fetch-shareinfo", {
    method: "GET",
    params,
  });
};

export {
  queryingStatus,
  taskRecord,
  getTask,
  check_boost,
  checkStarsOrderStatus,
  createStarsOrder3,
  taskReward,
  recordTask,
  fetchShareinfo,
};
